<template>
  <div>
    <div class="overlay"></div>
    <div class="modal_fixed">
      <div class="store_popup_box modal_cont" id="store_modal">
        <img src="static/images/store/icon-close-back-popup.svg" class="btn_close">
        <h1>{{ getTranslations.home_modals_invite_friend_title }}</h1>
        <p>{{ getTranslations.home_modals_invite_friend_description1 }} {{
            formattedValue(inviteConfig.invitePoints) }}
          {{ getTranslations.home_modals_invite_friend_description2 }}</p>
        <form-field :placeholder-text="getTranslations.home_modals_invite_friend_mobile_placeholder"
                    :submit-text="getTranslations.home_modals_invite_friend_submit"
                    :type-of-communication="'sms'"
                    :has-errors="phone.hasErrors"
                    :has-success="phone.hasSuccess"
                    :error-text="getTranslations.visitor_sign_up_invalid_msisdn_msg"
                    :success-text="getTranslations.home_modals_invite_friend_msisdn_success"
                    :title="getTranslations.home_modals_invite_friend_invite_via_sms"
                    :action-on-click="smsInvite"
                    @initiateValues="initiateValues(types.SMS)"/>

        <form-field :placeholder-text="getTranslations.home_modals_invite_friend_email_placeholder"
                    :submit-text="getTranslations.home_modals_invite_friend_submit"
                    :type-of-communication="'email'"
                    :has-errors="mail.hasErrors"
                    :has-success="mail.hasSuccess"
                    :error-text="getTranslations.home_modals_invite_friend_email_error"
                    :success-text="getTranslations.home_modals_invite_friend_email_success"
                    :title="getTranslations.home_modals_invite_friend_invite_via_email"
                    :action-on-click="emailInvite"
                    @initiateValues="initiateValues(types.MAIL)"/>

        <div v-if="facebookFunctionality && !hideFacebookPointFields">
          <h6>{{ getTranslations.home_modals_invite_friend_invite }}</h6>
          <button type="" class="invite_friends_btn" @click.prevent="shareFriendsInvitation()">
            <img src="static/images/home/logo-facebook.svg">
            <p>{{ getTranslations.home_store_share }}</p>
          </button>
          <span class="fb_error_msg" v-if="fb_error">{{ getTranslations.home_store_this_fb }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';
import FacebookMixin from '@/common/mixins/facebookIntegration';
import ValidationMixin from '@/common/mixins/validations';
import FormField from '../../sharedcomponents/FormField';

export default {
  name: 'invite-friend',
  mixins: [FacebookMixin, NumbersFormattingMixin, ValidationMixin],
  components: { FormField },
  data() {
    return {
      selectedType: '',
      selectedInput: '',
      types: {
        SMS: 'SMS',
        MAIL: 'EMAIL',
      },
      mail: {
        hasErrors: null,
        hasSuccess: null,
      },
      phone: {
        hasErrors: null,
        hasSuccess: null,
      },
      fb_error: false,
      redirectUrl: '',
    };
  },
  created() {
    this.redirectUrl = `${window.location.origin}/home/store/${this.getLocale || localStorage.getItem('locale')}/`;
    if (this.facebookFunctionality) {
      this.forceFbToScrapNewMetadata(this.redirectUrl, () => {
        // eslint-disable-next-line
        console.log('successful scrapping!');
      });
    }
  },
  methods: {
    ...mapActions('profile', [
      'sendFriendInvitation',
    ]),
    formattedValue(intValue) {
      if (this.integrationHeader === this.availableIntegrations.KOREK_IRAQ.name) {
        return intValue.toLocaleString();
      }
      return intValue;
    },
    initiateValues(type) {
      if (type === this.types.SMS) {
        this.phone.hasSuccess = null;
        this.phone.hasErrors = null;
      } else {
        this.mail.hasSuccess = null;
        this.mail.hasErrors = null;
      }
    },
    onSent() {
      if (this.selectedType === this.types.SMS) {
        this.phone.hasSuccess = true;
      } else {
        this.mail.hasSuccess = true;
      }
    },
    onError() {
      if (this.selectedType === this.types.SMS) {
        this.phone.hasErrors = true;
      } else {
        this.mail.hasErrors = true;
      }
    },
    emailInvite(input) {
      this.email = input;
      this.validateEmail();
      this.mail.hasErrors = this.hasErrors;
      if (!this.mail.hasErrors) {
        this.selectedType = this.types.MAIL;
        this.selectedInput = input;
        this.invite();
      }
    },
    smsInvite(input) {
      this.msisdn = input;
      this.validateMsisdn();
      this.phone.hasErrors = this.hasErrors;
      if (!this.phone.hasErrors) {
        this.selectedType = this.types.SMS;
        this.selectedInput = input;
        this.invite();
      }
    },
    invite() {
      const payload = {
        type: this.selectedType,
        name: this.userDetails.username,
        input: this.selectedInput,
      };
      this.sendFriendInvitation(payload).then((response) => {
        if (response.data.responseEnum === 'MSISDN_INVALID' || response.data.responseEnum === 'SERVER_ERROR') {
          this.onError();
        } else {
          this.onSent();
        }
      });
    },
    showError() {
      this.fb_error = true;
    },
    shareFriendsInvitation() {
      this.fb_error = false;
      this.share(
        this.userDetails.facebookId,
        this.userDetails.id,
        () => {
          // eslint-disable-next-line
          console.log('successful share invitation!');
        },
        this.showError,
      );
    },
  },
  computed: {
    ...mapState('common', [
      'hideFacebookPointFields',
      'availableIntegrations',
      'integrationHeader',
      'facebookFunctionality',
      'userDetails',
      'inviteConfig',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/users/InviteFriend.vue